import { render, staticRenderFns } from "./ImpressumFiliale.vue?vue&type=template&id=123dc3f4"
import script from "./ImpressumFiliale.vue?vue&type=script&lang=ts"
export * from "./ImpressumFiliale.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports